import React from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import Image2 from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/software/components/idea-engagement/index.tsx';
import Image1 from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/software/components/new-roadmap/index.tsx';
import Image3 from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/software/components/progress-in-idea/index.tsx';
import type { TemplateStaticContent } from '../../../../common/types.tsx';
import commonJPDMessages from '../messages.tsx';
import messages from './messages.tsx';

export const TEMPLATE_KEY = 'jpd.product-roadmap' as const;

export const roadMapProductDiscoveryProject: TemplateStaticContent = {
	key: TEMPLATE_KEY,
	overviewContent: {
		valueProps: [
			{
				title: messages.valueProp1Title,
				description: messages.valueProp1Description,
				imageUrl: '',
				imageComponent: () => <Image1 alt="" />,
			},
			{
				title: messages.valueProp2Title,
				description: messages.valueProp2Description,
				imageUrl: '',
				imageComponent: () => <Image2 alt="" />,
			},
			{
				title: messages.valueProp3Title,
				get description() {
					return expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
						? messages.valueProp3DescriptionSporkIssueTermRefresh
						: messages.valueProp3DescriptionSpork;
				},
				imageUrl: '',
				imageComponent: () => <Image3 alt="" />,
			},
		],
		recommendedList: [messages.recommendedList1],
		workType: 'Issue',
		issueTypes: [{ key: 'idea', label: commonJPDMessages.idea }],
		workflow: [
			{ label: commonJPDMessages.parkingLot, appearance: 'default' },
			{ label: commonJPDMessages.discovery, appearance: 'inprogress' },
			{ label: commonJPDMessages.readyForDelivery, appearance: 'inprogress' },
			{ label: commonJPDMessages.delivery, appearance: 'inprogress' },
			{ label: commonJPDMessages.impact, appearance: 'inprogress' },
			{ label: commonJPDMessages.archived, appearance: 'success' },
		],
	},
};
